// extracted by mini-css-extract-plugin
export default {"welcomePageContainer":"Welcome_welcomePageContainer__SH9TW","welcome":"Welcome_welcome__F33jd"};